import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChannelListUpdatedAtCell } from './channel-list-updated-at.cell';
import { ChannelListUpdatedAtHeader } from './channel-list-updated-at.header';

export const ChannelListUpdatedAtColumn: IdentifiedColumnDef<
  GatewayChannelWithChargePointInfoModel,
  GatewayChannelWithChargePointInfoModel['updatedAt']
> = {
  enableSorting: false,
  header: ChannelListUpdatedAtHeader,
  cell: ChannelListUpdatedAtCell,
};
